import { Typography, CircularProgress, Grid } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Wrapper } from "components/wrapper";
import { DetailCard, DetailField, DetailSectionTitle } from "components/detailPage";
import { useUnidadeSaudeDetailsState } from "./context/unidade-saude-details-context";
import { useUnidadeSaudeDetailsController } from "./context/unidade-saude-details-controller";

export function UnidadeSaudeDetailsPage() {
    const { unidadeSaudeDetails, loading, error } = useUnidadeSaudeDetailsState();
    const { loadUnidadeSaudeDetails, clearUnidadeSaudeDetails } = useUnidadeSaudeDetailsController();
    let { id } = useParams<{ id: string }>();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (id) {
            loadUnidadeSaudeDetails(parseInt(id));
        }

        return () => {
            clearUnidadeSaudeDetails();
        };
    }, [id, loadUnidadeSaudeDetails, clearUnidadeSaudeDetails]);

    if (loading) {
        return (
            <Wrapper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            </Wrapper>
        );
    }

    if (error) {
        return (
            <Wrapper>
                <Typography color="error" variant="h6">{error}</Typography>
            </Wrapper>
        );
    }

    if (!unidadeSaudeDetails) {
        return (
            <Wrapper>
                <Typography variant="h6">Unidade de saúde não encontrada.</Typography>
            </Wrapper>
        );
    }

    return (
        <>
            <Breadcrumb
                items={[
                    { label: "Home", href: "/" },
                    { label: "Unidades de Saúde", href: "/unidades-saude" },
                    { label: unidadeSaudeDetails.nomeUnidade },
                ]}
            />
            <PageTitle>{unidadeSaudeDetails.nomeUnidade}</PageTitle>
            <Wrapper>
                <DetailCard>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <DetailField label="Endereço" value={unidadeSaudeDetails.desEndereco} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DetailField label="Horário de Funcionamento" value={unidadeSaudeDetails.desHorarioFuncionamento} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DetailField label="Última Atualização" value={new Date(unidadeSaudeDetails.dtaAtualizacao).toLocaleDateString('pt-BR')} />
                        </Grid>

                        <Grid item xs={12}>
                            <DetailSectionTitle>Profissionais e Especialidades</DetailSectionTitle>
                        </Grid>

                        {(!unidadeSaudeDetails.profissionais || unidadeSaudeDetails.profissionais.length === 0) ? (
                            <Grid item xs={12}>
                                <Typography variant="body2">Nenhum profissional cadastrado.</Typography>
                            </Grid>
                        ) : (
                            unidadeSaudeDetails.profissionais.map((profissional) => (
                                <Grid item xs={12} sm={6} key={profissional.id}>
                                    <DetailField label={profissional.desEspecialidade} value={profissional.nomeProfissional} />
                                </Grid>
                            ))
                        )}
                    </Grid>
                </DetailCard>
            </Wrapper>
        </>
    );
}
